"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var storybook_1 = require("@eyecons/storybook");
function Hero(_a) {
    var channel = _a.channel, user = _a.user, firebase_supported = _a.firebase_supported, firebase_token = _a.firebase_token, requestFirebaseToken = _a.requestFirebaseToken;
    var _b = react_1.useState(0), plans = _b[0], setPlans = _b[1];
    return react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", null,
            react_1.default.createElement("div", { className: "storybook-channels-hero storybook-channels-hero-" + channel.type.name, style: { backgroundImage: "url(" + channel.banner + ")" } },
                react_1.default.createElement("div", { className: 'storybook-channels-hero-shadow' }),
                react_1.default.createElement(storybook_1.Layouts.Container, { className: 'storybook-channels-hero-channel' },
                    react_1.default.createElement("figure", null,
                        react_1.default.createElement("img", { src: channel.logo, alt: channel.label })),
                    react_1.default.createElement("div", null,
                        react_1.default.createElement("h1", null, channel.label),
                        react_1.default.createElement("span", null,
                            channel.videos_count,
                            " ",
                            channel.videos_count === 1 ? 'video' : 'video\'s')),
                    react_1.default.createElement("div", { className: 'storybook-channels-hero-buttons' },
                        react_1.default.createElement(storybook_1.Channels.Follow, { user: user, channel: channel }),
                        firebase_supported &&
                            react_1.default.createElement(storybook_1.Channels.PushNotifications, { channel: channel, firebase_token: firebase_token, requestFirebaseToken: requestFirebaseToken }))),
                channel.teams_count > 0 &&
                    channel.type.name === 'competition' &&
                    react_1.default.createElement(storybook_1.Layouts.Container, { className: 'z-20' },
                        react_1.default.createElement(storybook_1.Channels.Logos, { channel: channel })))),
        react_1.default.createElement(storybook_1.Channels.Plans, { setCount: setPlans, params: {
                channel_id: channel.id,
                paginate: 3,
                hidden: false,
            } }),
        react_1.default.createElement("div", { className: plans > 0 ? 'mt-8' : '' }, channel.type.name === 'club' && react_1.default.createElement(storybook_1.Events.Calender, { channel: channel })));
}
exports.default = Hero;
